var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x36_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-128 -128 768.00 768.00",
    xmlSpace: "preserve",
    width: "256px",
    height: "256px",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: -128,
    y: -128,
    width: 768,
    height: 768,
    rx: 384,
    fill: "#FFFFFF",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7436ee"
    },
    d: "M496.488,15.512V512H0.221V63.22H0V18.966h0.441C0.147,17.862,0,16.687,0,15.512 C0,6.983,6.91,0,15.511,0h465.467C489.579,0,496.488,6.983,496.488,15.512z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.977,
    y: 60.792,
    style: {
      fill: "#000000"
    },
    width: 478.535,
    height: 440.929
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.977,
    y: 60.792,
    style: {
      opacity: 0.06,
      fill: "#0D0D0D"
    },
    width: 478.535,
    height: 20.134
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#8BC66F"
    },
    cx: 121.998,
    cy: 31.584,
    rx: 11.773,
    ry: 12.532
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F4DB6D"
    },
    cx: 79.168,
    cy: 31.584,
    rx: 11.773,
    ry: 12.532
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#E06276"
    },
    cx: 36.339,
    cy: 31.584,
    rx: 11.773,
    ry: 12.532
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 132.793,
    y: 361.304,
    style: {
      fill: "#7436ee"
    },
    width: 62.849,
    height: 52.475
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 205.626,
    y: 402.887,
    style: {
      fill: "#7436ee"
    },
    width: 41.999,
    height: 7.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.626,
    y: 363.435,
    style: {
      fill: "#7436ee"
    },
    width: 86.751,
    height: 7.556
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.626,
    y: 383.079,
    style: {
      fill: "#7436ee"
    },
    width: 86.751,
    height: 7.556
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 132.793,
    y: 361.304,
    style: {
      opacity: 0.5,
      fill: "#7436ee"
    },
    width: 62.849,
    height: 52.475
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 205.626,
    y: 402.887,
    style: {
      fill: "#7436ee"
    },
    width: 41.999,
    height: 7.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.626,
    y: 363.435,
    style: {
      fill: "#7436ee"
    },
    width: 86.751,
    height: 7.556
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.626,
    y: 383.079,
    style: {
      fill: "#7436ee"
    },
    width: 86.751,
    height: 7.556
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 204.869,
    y: 463.572,
    style: {
      opacity: 0.5,
      fill: "#7436ee"
    },
    width: 86.751,
    height: 7.556
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.826,
    y: 186.479,
    style: {
      opacity: 0.5,
      fill: "#7436ee"
    },
    width: 88.745,
    height: 24.728
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.826,
    y: 227.217,
    style: {
      opacity: 0.5,
      fill: "#7436ee"
    },
    width: 88.745,
    height: 24.728
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.826,
    y: 267.955,
    style: {
      opacity: 0.5,
      fill: "#7436ee"
    },
    width: 88.745,
    height: 24.728
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.826,
    y: 308.692,
    style: {
      opacity: 0.5,
      fill: "#7436ee"
    },
    width: 88.745,
    height: 24.728
  })), /*#__PURE__*/React.createElement("rect", {
    x: 28.947,
    y: 149.097,
    style: {
      opacity: 0.5,
      fill: "#7436ee"
    },
    width: 438.595,
    height: 20.958
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.947,
    y: 436.925,
    style: {
      opacity: 0.5,
      fill: "#7436ee"
    },
    width: 438.595,
    height: 4.418
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 309.54,
    y: 360.62,
    style: {
      fill: "#7436ee"
    },
    width: 62.849,
    height: 52.475
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 382.373,
    y: 402.203,
    style: {
      fill: "#7436ee"
    },
    width: 41.999,
    height: 7.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.373,
    y: 362.751,
    style: {
      fill: "#7436ee"
    },
    width: 86.751,
    height: 7.556
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.373,
    y: 382.395,
    style: {
      fill: "#7436ee"
    },
    width: 86.751,
    height: 7.556
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 309.54,
    y: 360.62,
    style: {
      opacity: 0.5,
      fill: "#7436ee"
    },
    width: 62.849,
    height: 52.475
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 382.373,
    y: 402.203,
    style: {
      fill: "#7436ee"
    },
    width: 41.999,
    height: 7.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.373,
    y: 362.751,
    style: {
      fill: "#7436ee"
    },
    width: 86.751,
    height: 7.556
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.373,
    y: 382.395,
    style: {
      fill: "#7436ee"
    },
    width: 86.751,
    height: 7.556
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7BCAD4"
    },
    d: "M422.251,106.938c-0.679-2.9-2.087-5.582-4.068-7.789c-1.982-2.21-4.54-3.945-7.53-4.941 c-0.308-0.103-0.621-0.2-0.938-0.286c-2.809-0.768-5.643-0.808-8.308-0.242c-3.152,0.67-6.064,2.191-8.408,4.381l13.008,13.14 l0.03,0.031h-0.001l-0.03-0.031l-0.023,0.084l0,0l0.023-0.084L393,98.061c-2.306,2.157-4.066,4.958-4.96,8.228 c-0.895,3.27-0.805,6.576,0.083,9.606c0.905,3.08,2.637,5.87,5.01,8.051c0.02,0.018,0.039,0.038,0.062,0.055 c1.992,1.816,4.432,3.204,7.212,3.965c0.317,0.086,0.635,0.162,0.952,0.231c3.08,0.664,6.167,0.47,8.996-0.422 c0.025-0.008,0.052-0.017,0.077-0.027c2.8-0.896,5.347-2.479,7.388-4.611l0,0l0,0l0,0l0,0c1.964-2.051,3.46-4.608,4.262-7.54 C422.885,112.664,422.898,109.703,422.251,106.938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4F9FD8"
    },
    d: "M462.539,106.938c-0.679-2.9-2.087-5.582-4.068-7.789c-1.982-2.21-4.54-3.945-7.53-4.941 c-0.308-0.103-0.62-0.2-0.938-0.286c-2.809-0.768-5.643-0.808-8.308-0.242c-3.152,0.67-6.064,2.191-8.408,4.381l13.008,13.14 l0.03,0.031h-0.001l-0.03-0.031l-0.023,0.084l0,0l0.023-0.084l-13.008-13.14c-2.306,2.157-4.066,4.958-4.96,8.228 c-0.895,3.27-0.805,6.576,0.083,9.606c0.905,3.08,2.637,5.87,5.01,8.051c0.02,0.018,0.039,0.038,0.062,0.055 c1.992,1.816,4.432,3.204,7.212,3.965c0.317,0.086,0.635,0.162,0.953,0.231c3.08,0.664,6.167,0.47,8.996-0.422 c0.025-0.008,0.052-0.017,0.077-0.027c2.8-0.896,5.347-2.479,7.388-4.611l0,0l0,0l0,0l0,0c1.964-2.051,3.46-4.608,4.262-7.54 C463.173,112.664,463.186,109.703,462.539,106.938z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7436ee"
    },
    d: "M192.597,131.732v-28.229h-5.661v32.712h23.523v-4.483H192.597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7436ee"
    },
    d: "M242.069,115.264c-0.073-1.249-0.22-2.425-0.441-3.453c-0.294-1.03-0.661-1.985-1.176-2.794 c-0.441-0.881-1.176-1.691-2.059-2.5c-1.249-1.102-2.646-1.911-4.19-2.498c-1.544-0.515-3.381-0.809-5.366-0.809 c-2.058,0-3.896,0.294-5.44,0.809c-1.544,0.587-2.941,1.396-4.19,2.498c-0.882,0.809-1.617,1.619-2.058,2.5 c-0.515,0.809-0.882,1.764-1.176,2.794c-0.22,1.028-0.367,2.204-0.441,3.453c0,1.324-0.074,2.868-0.074,4.558 c0,1.691,0.074,3.234,0.074,4.559c0.074,1.249,0.221,2.425,0.441,3.455c0.294,1.028,0.662,1.983,1.176,2.866 c0.441,0.809,1.176,1.691,2.058,2.426c1.25,1.102,2.646,1.911,4.19,2.498c1.544,0.589,3.382,0.809,5.44,0.809 c1.985,0,3.823-0.221,5.366-0.809c1.544-0.587,2.941-1.396,4.19-2.498c0.882-0.736,1.618-1.617,2.059-2.426 c0.515-0.883,0.882-1.838,1.176-2.866c0.221-1.03,0.368-2.206,0.441-3.455c0-1.325,0.074-2.868,0.074-4.559 C242.143,118.132,242.069,116.588,242.069,115.264z M236.409,123.939c0,1.102-0.147,1.985-0.294,2.792 c-0.147,0.736-0.368,1.325-0.661,1.838c-0.294,0.515-0.662,0.956-1.103,1.396c-0.735,0.662-1.543,1.177-2.499,1.545 c-0.882,0.368-1.911,0.515-3.014,0.515c-1.176,0-2.205-0.147-3.087-0.515c-0.956-0.368-1.764-0.883-2.5-1.545 c-0.441-0.44-0.809-0.881-1.102-1.396c-0.294-0.513-0.515-1.102-0.662-1.911c-0.147-0.734-0.294-1.691-0.294-2.792 c-0.074-1.028-0.074-2.426-0.074-4.043c0-1.617,0-3.013,0.074-4.117c0-1.102,0.147-1.985,0.294-2.719 c0.147-0.809,0.368-1.398,0.662-1.911c0.294-0.515,0.661-1.03,1.102-1.472c1.47-1.323,3.308-1.983,5.587-1.983 c2.205,0,4.043,0.66,5.513,1.983c0.441,0.441,0.809,0.883,1.103,1.398c0.294,0.515,0.515,1.175,0.661,1.911 c0.147,0.808,0.294,1.691,0.294,2.793c0.074,1.104,0.074,2.5,0.074,4.117C236.483,121.439,236.483,122.837,236.409,123.939z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7436ee"
    },
    d: "M262.432,118.499v4.262h7.939v1.766c0,1.102-0.147,2.057-0.441,2.866 c-0.221,0.881-0.735,1.617-1.397,2.353c-0.735,0.734-1.618,1.323-2.72,1.691c-1.029,0.441-2.206,0.589-3.382,0.589 c-2.205,0-4.043-0.662-5.513-1.985c-0.441-0.441-0.809-0.883-1.103-1.472c-0.294-0.513-0.514-1.102-0.735-1.838 c-0.147-0.808-0.22-1.691-0.294-2.792c-0.074-1.102-0.074-2.5-0.074-4.117c0-1.617,0-3.013,0.074-4.117 c0.074-1.102,0.147-1.985,0.294-2.719c0.221-0.809,0.441-1.398,0.735-1.911c0.294-0.515,0.662-1.03,1.103-1.472 c1.47-1.323,3.308-1.983,5.513-1.983c2.059,0,3.749,0.515,5.072,1.47c1.323,1.028,2.279,2.426,2.72,4.189h5.66 c-0.294-1.323-0.735-2.645-1.397-3.895c-0.735-1.177-1.617-2.279-2.793-3.234c-1.103-0.883-2.426-1.619-4.043-2.132 c-1.544-0.589-3.308-0.809-5.219-0.809c-2.058,0-3.823,0.294-5.44,0.809c-1.544,0.587-2.941,1.396-4.117,2.498 c-0.956,0.809-1.617,1.619-2.132,2.5c-0.514,0.809-0.882,1.764-1.102,2.794c-0.294,1.028-0.441,2.204-0.441,3.453 c-0.074,1.324-0.074,2.868-0.074,4.558c0,1.691,0,3.234,0.074,4.559c0,1.249,0.147,2.425,0.441,3.455 c0.22,1.028,0.588,1.983,1.102,2.866c0.515,0.809,1.176,1.691,2.132,2.426c1.176,1.102,2.573,1.911,4.117,2.498 c1.617,0.589,3.382,0.809,5.44,0.809c1.985,0,3.823-0.294,5.513-0.881c1.764-0.589,3.308-1.545,4.705-2.794 c1.176-1.176,2.058-2.5,2.573-3.896c0.515-1.396,0.735-3.234,0.735-5.366v-4.998H262.432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7436ee"
    },
    d: "M309.478,115.264c-0.073-1.249-0.221-2.425-0.441-3.453c-0.294-1.03-0.662-1.985-1.103-2.794 c-0.515-0.881-1.25-1.691-2.132-2.5c-1.25-1.102-2.647-1.911-4.19-2.498c-1.544-0.515-3.382-0.809-5.367-0.809 c-2.058,0-3.896,0.294-5.44,0.809c-1.543,0.587-2.94,1.396-4.19,2.498c-0.882,0.809-1.617,1.619-2.058,2.5 c-0.515,0.809-0.882,1.764-1.176,2.794c-0.22,1.028-0.367,2.204-0.441,3.453c0,1.324-0.073,2.868-0.073,4.558 c0,1.691,0.073,3.234,0.073,4.559c0.074,1.249,0.221,2.425,0.441,3.455c0.294,1.028,0.662,1.983,1.176,2.866 c0.441,0.809,1.176,1.691,2.058,2.426c1.25,1.102,2.647,1.911,4.19,2.498c1.544,0.589,3.382,0.809,5.44,0.809 c1.985,0,3.823-0.221,5.367-0.809c1.543-0.587,2.94-1.396,4.19-2.498c0.882-0.736,1.617-1.617,2.132-2.426 c0.441-0.883,0.809-1.838,1.103-2.866c0.22-1.03,0.368-2.206,0.441-3.455c0-1.325,0.073-2.868,0.073-4.559 C309.552,118.132,309.478,116.588,309.478,115.264z M303.818,123.939c0,1.102-0.147,1.985-0.294,2.792 c-0.147,0.736-0.368,1.325-0.662,1.838c-0.294,0.515-0.662,0.956-1.103,1.396c-0.735,0.662-1.543,1.177-2.499,1.545 c-0.882,0.368-1.911,0.515-3.014,0.515c-1.176,0-2.205-0.147-3.087-0.515c-0.956-0.368-1.764-0.883-2.499-1.545 c-0.441-0.44-0.809-0.881-1.103-1.396c-0.294-0.513-0.515-1.102-0.662-1.911c-0.147-0.734-0.294-1.691-0.294-2.792 c-0.074-1.028-0.074-2.426-0.074-4.043c0-1.617,0-3.013,0.074-4.117c0-1.102,0.147-1.985,0.294-2.719 c0.147-0.809,0.368-1.398,0.662-1.911c0.294-0.515,0.662-1.03,1.103-1.472c1.47-1.323,3.308-1.983,5.586-1.983 c2.206,0,4.044,0.66,5.513,1.983c0.441,0.441,0.809,0.883,1.103,1.398c0.294,0.515,0.515,1.175,0.662,1.911 c0.147,0.808,0.294,1.691,0.294,2.793c0.074,1.104,0.074,2.5,0.074,4.117C303.892,121.439,303.892,122.837,303.818,123.939z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 132.492,
    y: 186.855,
    style: {
      fill: "#FFFFFF"
    },
    width: 335.05,
    height: 162.198
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.8,
      fill: "#7436ee"
    },
    cx: 284.444,
    cy: 218.287,
    rx: 24.088,
    ry: 23.52
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7436ee"
    },
    d: "M324.926,349.054H132.793l68.302-78.896c15.254-17.637,40.275-17.637,55.529,0l25.924,29.985 L324.926,349.054z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7436ee"
    },
    d: "M467.542,313.711v35.343H243l42.534-48.911l56.577-64.989c15.671-18.112,41.449-18.112,57.119,0 L467.542,313.711z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.412f3f56a20412d2a7422a1386a8551e.svg";
export { ForwardRef as ReactComponent };